import { Linktrainrelaymixer } from '@linktivity/eticketportal';
import { message } from '@linktivity/link-ui';

const BASE_PATH = import.meta.env.VITE_API_SHINKANSEN_HOST;

const config = new Linktrainrelaymixer.Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async context => {
        const requestHeaders: HeadersInit = new Headers({
          'Content-Type': 'application/json'
        });
        context.init.headers = requestHeaders;
      },
      post: async context => {
        if (!context.response.ok) {
          // handle error
          const data = await context.response.json();
          message.error(
            data.common?.error_description || data.common?.error_code,
            10
          );
        }
      }
    }
  ]
});

const linktrainrelay = new Linktrainrelaymixer.LinktrainrelaymixerApi(config);

export default linktrainrelay;
